module.exports = __webpack_public_path__ + "img/whatsapp.659dc892.png";